import "/public/css/order.css";
import { ref, onMounted, onBeforeMount, onBeforeUnmount } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from "vue-router";
import httpRequest from '@/request/index';
import { showFailToast } from 'vant';
export default {
  setup() {
    const store = useStore();
    const router = useRouter();
    let page = ref(1),
      pageSize = ref(10);
    let loading = ref(false),
      finished = ref(false);
    let list = ref([]);
    const loadData = () => {
      httpRequest({
        method: "get",
        url: "?file=refund",
        params: {
          limit: pageSize.value,
          page: page.value
        }
      }).then(res => {
        if (res.state == 1) {
          loading.value = false;
          const _list = res.list;
          list.value = [...list.value, ..._list];
          if (_list.length < pageSize.value) {
            console.log("没有了");
            finished.value = true;
          }
          page.value++;
        } else {
          showFailToast(res.msg);
        }
      });
    };
    onBeforeMount(() => {
      document.getElementsByTagName("body")[0].className = "bg_body";
    });
    onBeforeUnmount(() => {
      document.body.removeAttribute("class", "bg_body");
    });
    onMounted(async () => {
      await store.dispatch("cklogin").then(() => {
        if (!store.state.isLogin) {
          router.replace("/login");
        }
      });
    });
    const goBack = () => {
      router.go(-1);
    };
    return {
      list,
      goBack,
      loadData,
      finished,
      loading
    };
  }
};